import baseapi from "../baseAPI";
import {successMesg, errorMesg} from "./../../Pages/Toaster";

export const CampaignAPI = async (setCampaigns, setLoading, currentPage, perpagedata, setPageCount, setTotalRecords, params) =>
{
    setLoading(true);

    let searchparam = "";

    if(params !== "" && params !== null && params !== undefined)
    {
            searchparam = `?${params.toString()}`;
        
    }
    else
    {
            searchparam = "?page=" + currentPage + "&per_page=" + perpagedata;
    }

    try 
    {
        const response = await baseapi.get("/api/marketing/campaigns" + searchparam);

        console.log("Data got successfully", response.data.datalist.data);
        //let userdata = ['ram', 'shyam', 'rohit'];

        if(response.data !== "" && response.data !== null && response.data !== undefined)
        {            
            setCampaigns(response.data.datalist.data);

            if(response.data.datalist.total > 0)
            {
                console.log('Total count====='+response.data.datalist.total);
                let pagecount = Math.ceil(response.data.datalist.total / perpagedata);

                console.log('page count====' + pagecount);

                setPageCount(pagecount);

                setTotalRecords(response.data.datalist.total);
            }

            setLoading(false);
        }
        else
        {
            errorMesg("Invalid user");
            setLoading(false);
        }
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}



